import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';

import { CertificatesTab } from '../CertificatesTab';
import { DataStatusOptionsDuplicates, defaultPageRowOptions, paginatorLinks, showingEntries, defaultRowOptions, DUPLICATECERTYNAME, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { Toolbar } from 'primereact/toolbar';
import { DuplicateCertListShowColumns } from '../../../appconfig/DatatableSetting';
import { DUPLICATE_CERTIFICATE_CHANGE_STATUS, DUPLICATE_CERTIFICATE_LIST } from '../../../config/ApiConstant';
import { getAllDetails } from '../../../service/ProductService';
import moment from 'moment';
import { setOtherAppStatus } from '../../../appconfig/AppHelper';
import { createdAtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const DuplicateCertificateList = () => {
    document.title = 'Duplicate Certificate | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('duplicate_certificates_list');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [certificateList, setCertificateList] = useState<any>([]);
    const [status, setStatus] = useState<any>(DataStatusOptionsDuplicates[0]);
    const [generateStatusModal, setGenerateStatusModal] = useState<boolean>(false);
    const [generateStatusLoader, setGenerateStatusLoader] = useState<boolean>(false);
    const [RNo, setRNo] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getCertificateList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // Get certificate list
    const getCertificateList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(DUPLICATE_CERTIFICATE_LIST + '?start_date=' + startDate + '&end_date=' + endDate + '&AppNm=' + DUPLICATECERTYNAME);
            if (response) {
                setPageLoad(true);
                setCertificateList(response);
            }
        } catch (error: any) {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'duplicate_certificates_list',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Search by status
    const searchByStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={status}
                onChange={(e: any) => {
                    setStatus(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={DataStatusOptionsDuplicates}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        let appStatusVal = setOtherAppStatus(rowData.duplicate_certificate_status);
        return (
            <>
                <div className="actions">
                    <Badge severity={appStatusVal.severity} value={appStatusVal.value}></Badge>
                </div>
            </>
        );
    };

    // Template for file url
    const fileUrlTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button
                        icon="pi pi-download"
                        tooltip="Download Certificate"
                        tooltipOptions={{ position: 'top' }}
                        className="p-button-primary"
                        onClick={() => window.open(rowData.file_url, '_blank')}
                        disabled={!window.cn(rowData.file_url) && rowData?.duplicate_certificate_status === 1 ? false : true}
                    />
                </div>
            </>
        );
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button
                        icon="fa-solid fa-rotate"
                        tooltip="Change Generate Status"
                        tooltipOptions={{ position: 'top' }}
                        className="p-button-primary"
                        onClick={() => openGenerateStatusModal(rowData.RNo)}
                        disabled={rowData.duplicate_certificate_status === 0 ? false : true}
                    />
                </div>
            </>
        );
    };

    // Open generate status modal
    const openGenerateStatusModal = (RNo: any) => {
        setRNo(RNo);
        setGenerateStatusModal(true);
    };

    // Close generate status modal
    const closeGenerateStatusModal = () => {
        setRNo(null);
        setGenerateStatusModal(false);
    };

    // Generate status change
    const generateStatusChange = async () => {
        try {
            setGenerateStatusLoader(true);

            const response = await getAllDetails(DUPLICATE_CERTIFICATE_CHANGE_STATUS + '?RNo=' + RNo);
            if (response) {
                setRNo(null);
                setGenerateStatusLoader(false);
                setGenerateStatusModal(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Message',
                    detail: response
                });
                setTimeout(() => {
                    getCertificateList();
                }, 1000);
            }
        } catch (error: any) {
            setGenerateStatusLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Something Went Wrong'
            });
        }
    };

    return (
        <>
           <CertificatesTab  mainTabLabel="Duplicate Certificate" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Certificates Found"
                                    removableSort
                                >
                                    {DuplicateCertListShowColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'duplicate_certificate_status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByStatus} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={createdAtTemplate} />;
                                        } else if (col.field === 'file_url') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={fileUrlTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {DuplicateCertListShowColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Delete With Refund Dialog */}
            <Dialog
                visible={generateStatusModal}
                style={{ width: '450px' }}
                header="Change Certificate Generate Status"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeGenerateStatusModal} />
                        <Button label="Submit" icon="pi pi-check" onClick={generateStatusChange} loading={generateStatusLoader} />
                    </>
                }
                onHide={closeGenerateStatusModal}
            >
                <p>Are you sure you want to change certificate generate status?</p>
            </Dialog>
        </>
    );
};
